import { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { EASE, EASE_CUT } from "@/lib/motion";

const WORD = "PORTFOLIO";
const TITLE_GLYPHS = Array.from(WORD, (character, position) => ({
  id: `portfolio-glyph-${position}-${character}`,
  character,
  delay: 0.2 + position * 0.04,
}));

export const TitleSequence = ({ onDone }) => {
  const reduce = useReducedMotion();
  const [show, setShow] = useState(!reduce);
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    if (reduce) {
      onDone?.();
      return;
    }
    document.body.style.overflow = "hidden";
    const int = setInterval(() => setFrame((f) => f + 1), 42);
    const t = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = "";
      onDone?.();
    }, 2200);
    return () => {
      clearInterval(int);
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [reduce, onDone]);

  const tc = `00:00:${String(Math.floor(frame / 24) % 60).padStart(2, "0")}:${String(
    frame % 24
  ).padStart(2, "0")}`;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="title-sequence"
          className="fixed inset-0 z-[70] flex flex-col justify-between overflow-hidden bg-[#0a0a0a] px-5 py-6 md:px-10 md:py-8"
          exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 0.9, ease: EASE_CUT }}
        >
          <div className="flex items-start justify-between">
            <motion.span
              className="label text-[#666]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              HSK<span className="text-[#d4ff00]">®</span> / REEL 01
            </motion.span>
            <motion.span
              className="font-mono text-[10px] tracking-[0.2em] text-[#d4ff00]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              {tc}
            </motion.span>
          </div>

          <div className="relative">
            <motion.div
              className="pointer-events-none absolute left-0 top-1/2 h-[1px] w-full bg-[#d4ff00]"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.7, ease: EASE, delay: 0.2 }}
              style={{ transformOrigin: "left" }}
            />
            <h1 className="relative flex justify-center overflow-hidden text-center font-display text-[15vw] font-black leading-none tracking-tighter text-[#e5e5e5] md:text-[13.5vw]">
              {TITLE_GLYPHS.map((glyph) => (
                <span key={glyph.id} className="mask-line">
                  <motion.span
                    className="block"
                    initial={{ y: "115%", filter: "blur(14px)", opacity: 0 }}
                    animate={{ y: 0, filter: "blur(0px)", opacity: 1 }}
                    transition={{
                      duration: 0.9,
                      ease: EASE,
                      delay: glyph.delay,
                    }}
                  >
                    {glyph.character}
                  </motion.span>
                </span>
              ))}
            </h1>
          </div>

          <div className="flex items-end justify-between">
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1, duration: 0.7, ease: EASE }}
              className="label text-[#8a8a8a]"
            >
              HARSH KOTWANI / VIDEO EDITOR
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.1, duration: 0.7, ease: EASE }}
              className="label text-[#8a8a8a]"
            >
              WORKING WORLDWIDE
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
